module.exports = __webpack_public_path__ + "img/moncalieri_arch_hero_card.7b8596f0.png";